<template>
  <div :class="[$style.mothers_fathers_day_2025, ...[isFathersDay ? $style.fathers_day : $style.mothers_day]]">
    <section :class="[$style.header_section, $style.no_padding]" class="first-view">
      <h1 :class="$style.title">
        <AtomsConsumerImage
          :src="images.mainPc"
          alt="TENTIAL Mother's Day & Father's Day"
          :class="[$style.main_image, $style.pc_image]"
          :width="1600"
          :height="870"
        />
        <AtomsConsumerImage
          :src="images.mainSp"
          alt="TENTIAL Mother's Day & Father's Day"
          :class="[$style.main_image, $style.sp_image]"
          :width="375"
          :height="670"
        />
      </h1>
    </section>
    <section :class="$style.intro">
      <h2 :class="$style.label_title" class="scroll-fade">
        いつまでも元気でいてほしいから<br />
        母の日・父の日に贈る<br v-if="!md" />
        一年に一度の「ありがとう」
      </h2>
      <div :class="$style.description" class="scroll-fade">
        「いつもありがとう」――心ではそう思っていても、<br />
        気恥ずかしさや日々の忙しさで、<br v-if="!md" />
        ちゃんと伝えられていない両親への気持ち。<br />
        離れて暮らしているからこそ、<br />
        「元気にしてるかな」「ゆっくり休めているかな」<br v-if="!md" />
        実はいつも気にかけているんです。<br />
        <br v-if="!md" />
        気がつけば、もうすぐ母の日・父の日。<br />
        「何もいらないからね」と優しい声で<br v-if="!md" />
        そう言ってくれるけど、<br />
        今年は「いつまでも、元気な笑顔でいてほしい」の<br v-if="!md" />
        願いを込めて、<br />
        TENTIALで「ありがとうギフト」を<br v-if="!md" />
        贈ってみませんか。
      </div>
      <AtomsConsumerImage
        :src="images.thankYouPc"
        alt="Thank you, Mom"
        :class="[$style.intro_image, $style.pc_image]"
        class="scroll-fade"
        :width="980"
        :height="559"
      />
      <AtomsConsumerImage
        :src="images.thankYouSp"
        alt="Thank you, Mom"
        :class="[$style.intro_image, $style.sp_image]"
        class="scroll-fade"
        :width="335"
        :height="226"
      />
      <div :class="$style.navigation_list" class="scroll-fade">
        <AtomsConsumerButton @click="scrollToId('campaign')">
          <p :class="$style.number">01</p>
          <div :class="$style.title"
            ><p>キャンペーン<br v-if="md" />内容</p></div
          >
          <p :class="$style.arrow">↓</p>
        </AtomsConsumerButton>
        <AtomsConsumerButton @click="scrollToId('gift-set')">
          <p :class="$style.number">02</p>
          <p :class="$style.title">キャンペーン限定<br />お得なギフトセット</p>
          <p :class="$style.arrow">↓</p>
        </AtomsConsumerButton>
        <AtomsConsumerButton @click="scrollToId('what-is-bakune')">
          <p :class="$style.number">03</p>
          <p :class="$style.title">BAKUNE<br />3つのこだわり</p>
          <p :class="$style.arrow">↓</p>
        </AtomsConsumerButton>
        <AtomsConsumerButton @click="scrollToId('gift-service')">
          <p :class="$style.number">04</p>
          <p :class="$style.title">TENTIALの<br />特別なギフトサービス</p>
          <p :class="$style.arrow">↓</p>
        </AtomsConsumerButton>
      </div>
    </section>
    <section id="campaign" :class="$style.campaign">
      <div :class="$style.title_wrapper" class="scroll-fade">
        <div :class="$style.campaign_title">
          <div :class="$style.label_title">
            TENTIAL<br />
            Mother’s & Father’s Day Campaign
          </div>
        </div>
        <p :class="$style.date">2025年4月25日(Fri)ー6月16日(Mon)</p>
        <p :class="$style.date_note">※オンラインストア 〜 6/16 11:59</p>
        <div v-if="isFathersDayDeliverable" :class="$style.delivery_date_note">
          <p :class="[$style.delivery_date_note_item, $style.red_text]">
            <span :class="$style.bg_white">
              ※<span :class="$style.underline">父の日当日 6月15日（日）までのお届け</span
              >をご希望の場合は、<br />6月10日（火）中のご注文をお願いいたします。</span
            >
          </p>
          <p :class="$style.delivery_date_note_item">
            ※ご注文が集中した場合、予定よりも早く受付を終了させていただくことがございます。<br />
            ※配送状況により、お届けが前後する可能性もございますので、お早めのご注文をおすすめいたします。
          </p>
        </div>
        <div :class="$style.campaign_note">
          キャンペーン期間中に<br v-if="md" />対象のTENTIAL STOREで<br
            v-if="!md"
          />ギフトとしてご購入いただいた方に<span>3つの特典</span>！
        </div>
      </div>
      <div :class="$style.side_by_side_items">
        <div :class="$style.side_item" class="scroll-fade">
          <div :class="$style.number_sp">
            <AtomsConsumerImage :src="images.number1" alt="1/3" :width="54" :height="47" />
          </div>
          <div :class="$style.item">
            <div :class="$style.content">
              <p :class="$style.number">01</p>
              <h3 :class="$style.title">{{
                `全商品対象、キャンペーン期間中に\nギフトとしてご購入の方に\n数量限定で無料ラッピングをサービス。`
              }}</h3>
              <p :class="$style.description">限定カラー（ベージュ）のラッピング袋は終了しました。</p>
              <p :class="$style.tips">※無料ラッピングはなくなり次第終了します。</p>
            </div>
            <AtomsConsumerImage
              src="/images/site/feature/mothers-fathers-day-2025/campaign-01.jpeg"
              alt="全商品対象、キャンペーン期間中にギフトとしてご購入の方に数量限定で無料ラッピングをサービス。"
              :class="$style.image_wrapper"
              :width="md ? 720 : 335"
              :height="md ? 408 : 190"
              @click="showModal('/images/site/feature/mothers-fathers-day-2025/campaign-01.jpeg')"
            />
          </div>
          <AtomsConsumerImage
            :src="images.freeWrapping"
            alt="ラッピング袋無料"
            :width="105"
            :height="105"
            :class="$style.free_wrapping"
          />
        </div>
        <div :class="$style.side_item" class="scroll-fade">
          <div :class="$style.number_sp">
            <AtomsConsumerImage :src="images.number2" alt="2/3" :width="54" :height="47" />
          </div>
          <div :class="$style.item">
            <div :class="$style.content">
              <p :class="$style.number">02</p>
              <h3 :class="$style.title">{{ `ご両親への感謝の気持ちが伝わる、\nメッセージカードをご用意。` }}</h3>
              <p :class="$style.description">{{
                `限定デザインのメッセージカードもご用意しました。\n一年に一度、ご両親への感謝の気持ちをオリジナルカードで伝えてみませんか。`
              }}</p>
              <p :class="$style.tips">
                ※メッセージカードは有料（税込110円）です。<br />
                ※商品購入時に「ギフトラッピング設定」でご希望のカードを選択してください。 <br />
                ※オリジナルメッセージの印字サービスはございません。
              </p>
            </div>
            <AtomsConsumerImage
              src="/images/site/feature/mothers-fathers-day-2025/campaign-02-end.jpeg"
              alt="ご両親への感謝の気持ちが伝わる、メッセージカードをご用意（販売終了）"
              :class="[$style.image_wrapper, $style.no_pointer]"
              :width="md ? 720 : 335"
              :height="md ? 408 : 190"
            />
          </div>
        </div>
        <div :class="$style.side_item" class="scroll-fade">
          <div :class="$style.number_sp">
            <AtomsConsumerImage :src="images.number3" alt="3/3" :width="54" :height="47" />
          </div>
          <div :class="$style.item">
            <div :class="$style.content">
              <p :class="$style.number">03</p>
              <h3 :class="$style.title">
                {{ `「ありがとう」の気持ちを込めて、\nスペシャルギフトカードを\n数量限定で差し上げます。` }}
              </h3>
              <p :class="$style.description">カード裏面にTENTIALの気持ちを込めました。</p>
            </div>
            <AtomsConsumerImage
              src="/images/site/feature/mothers-fathers-day-2025/campaign-03-end.jpeg"
              alt="「ありがとう」の気持ちを込めて、スペシャルギフトカードを数量限定で差し上げます。（販売終了）"
              :class="$style.image_wrapper"
              :width="md ? 720 : 335"
              :height="md ? 408 : 190"
            />
          </div>
        </div>
      </div>
    </section>
    <section id="gift-set" :class="$style.gift_set">
      <h2 :class="$style.label_title" class="scroll-fade">
        <p :class="[$style.label, $style.pink, $style.text_xl, $style.space]">いつまでも元気な笑顔でいてほしい。</p>
        <p :class="[$style.label, $style.blue, $style.text_xl, $style.space]"
          >TENTIAL 母の日・父の日ギフトセレクション</p
        >
        <p :class="[$style.label, $style.white, $style.text_md]">期間限定 TENTIALの「母の日・父の日ギフト」</p>
        <div>
          <div :class="[$style.label, $style.text_sm, $style.note]">
            <div>※</div
            ><div
              >{{
                isFathersDay ? "父" : "母"
              }}の日直前はご注文が殺到して品薄になる商品もございますので、お早めのご注文をおすすめしております。</div
            >
          </div>
          <div :class="[$style.label, $style.text_sm, $style.note]">
            <div>※</div><div>ノベルティプレゼントはキャンペーンページから限定セットご購入の方が対象となります。</div>
          </div>
        </div>
      </h2>
      <div :class="$style.gift_products">
        <div v-for="cartItem of giftSetProducts" :key="cartItem.title" :class="$style.product_wrapper">
          <AtomsConsumerImage
            v-if="cartItem.bannerPc"
            :src="cartItem.bannerPc"
            :alt="cartItem.title"
            :class="[$style.title_image, $style.pc_image]"
            class="scroll-fade"
            :width="1440"
            :height="683"
          />
          <AtomsConsumerImage
            v-if="cartItem.bannerSp"
            :src="cartItem.bannerSp"
            :alt="cartItem.title"
            :class="[$style.title_image, $style.sp_image]"
            class="scroll-fade"
            :width="335"
            :height="188"
          />
          <div :class="[$style.product, { [$style.most_popular]: cartItem.isMostPopular }]" class="scroll-fade">
            <div v-if="isSetSoldOut(cartItem)" :class="$style.sold_out">
              <div>SOLD OUT</div>
            </div>
            <div :class="[$style.product_item, { [$style.not_click]: isSetSoldOut(cartItem) }]">
              <div :class="$style.pc_images">
                <div :class="$style.image_wrapper">
                  <template v-for="(product, index1) in cartItem.products">
                    <div
                      v-for="(item, index2) in product.selectItems.filter(
                        (item) => item.index === Number(cartItem.selectedProducts[index1]),
                      )"
                      :key="`product-${index1}-${index2}`"
                      :class="$style.product_image"
                    >
                      <AtomsConsumerImage
                        :src="item.img"
                        :alt="item.productName"
                        :class="$style.image"
                        :width="338"
                        :height="451"
                      />
                      <p :class="$style.item_name">{{ item.productName }}</p>
                      <p>{{ item.subtext }}</p>
                    </div>
                  </template>
                </div>
                <div v-if="md && cartItem.novelty" :class="[$style.novelty, $style.novelty_pc]">
                  <div :class="$style.novelty_wrapper">
                    <div :class="$style.novelty_image_wrapper">
                      <div :class="[$style.novelty_image, { [$style.out_of_stock]: !cartItem.novelty.isInStock }]">
                        <AtomsConsumerImage
                          :src="cartItem.novelty.img"
                          :alt="`${cartItem.productNames}のノベルティ`"
                          :width="238"
                          :height="195"
                        />
                      </div>
                    </div>
                    <div :class="$style.novelty_text">
                      <div>
                        <p
                          ><span>{{ cartItem.novelty.text }}</span></p
                        >
                        <div :class="$style.note">{{ cartItem.novelty.note }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div :class="$style.detail">
                <div :class="$style.product_info">
                  <div :class="$style.label_title">
                    <p :class="[$style.label, $style.pink, $style.text_md, $style.space]">{{ cartItem.title }}</p>
                    <p :class="[$style.label, $style.blue, $style.text_md, $style.space]">{{ cartItem.subTitle }}</p>
                  </div>
                  <div>
                    <p v-if="cartItem.isNewItem" :class="$style.new_item_label">NEW ITEM</p>
                    <p v-if="cartItem.discountLate" :class="$style.discount">
                      キャンペーン限定価格<span :class="$style.discount_late">{{ cartItem.discountLate }}%OFF</span>
                    </p>
                    <p :class="$style.product_name">{{ cartItem.productNames }}</p>
                  </div>
                  <div>
                    <p :class="$style.description">{{ cartItem.description }}</p>
                    <div v-if="cartItem.bakuneCategory" :class="$style.link" @click="scrollToId('what-is-bakune')">
                      BAKUNE ３つのこだわり↓
                    </div>
                  </div>

                  <div :class="$style.product_list_wrapper">
                    <PagePartsProductListCarousel :item-length="2">
                      <template #items>
                        <template v-for="(product, index1) in cartItem.products">
                          <div
                            v-for="(item, index2) in product.selectItems.filter(
                              (item) => item.index === Number(cartItem.selectedProducts[index1]),
                            )"
                            :key="`product-${index1}-${index2}`"
                            :class="$style.product_image"
                          >
                            <AtomsConsumerImage
                              :src="item.img"
                              :alt="item.productName"
                              :width="239"
                              :height="320"
                              :class="$style.image"
                            />
                            <p :class="$style.item_name">{{ item.productName }}</p>
                            <p>{{ item.subtext }}</p>
                          </div>
                        </template>
                      </template>
                      <template #spItems>
                        <template v-for="(product, index1) in cartItem.products">
                          <div
                            v-for="(item, index2) in product.selectItems.filter(
                              (item) => item.index === Number(cartItem.selectedProducts[index1]),
                            )"
                            :key="`product-${index1}-${index2}`"
                            :class="$style.product_image"
                          >
                            <AtomsConsumerImage
                              :src="item.img"
                              :alt="item.productName"
                              :width="239"
                              :height="320"
                              :class="$style.image"
                            />
                            <p :class="$style.item_name">{{ item.productName }}</p>
                            <p>{{ item.subtext }}</p>
                          </div>
                        </template>
                      </template>
                    </PagePartsProductListCarousel>
                  </div>
                  <hr />
                  <template v-if="cartItem.products.length > 0 && cartItem.products[0].selectItems.length > 1">
                    <div v-for="(product, index) of cartItem.products" :key="`${cartItem.title}-${index}`">
                      <template v-if="product.selectItems.length > 0">
                        <p v-if="product.selectLabel" :class="$style.select_label">{{ product.selectLabel }}</p>
                        <div v-if="product.selectItems.length === 1" :class="$style.one_select_product">{{
                          product.selectItems[0].selectName
                        }}</div>
                        <AtomsConsumerSelect
                          v-else
                          v-model="cartItem.selectedProducts[index]"
                          placeholder="選択してください"
                          :options="product.selectItems"
                          option-value="index"
                          option-label="selectName"
                          :class="$style.select"
                        />
                      </template>
                    </div>
                  </template>
                  <div v-if="cartItem.products_note" :class="$style.products_note">
                    <div>※</div><div>{{ cartItem.products_note }}</div>
                  </div>
                  <div v-if="cartItem.novelty" :class="[$style.novelty, $style.novelty_sp]">
                    <div :class="$style.novelty_wrapper">
                      <div :class="$style.novelty_image_wrapper">
                        <div :class="[$style.novelty_image, { [$style.out_of_stock]: !cartItem.novelty.isInStock }]">
                          <AtomsConsumerImage
                            :src="cartItem.novelty.img"
                            :alt="`${cartItem.productNames}のノベルティ`"
                            :width="84"
                            :height="84"
                          />
                        </div>
                      </div>
                      <div :class="$style.novelty_text">
                        <p
                          ><span>{{ cartItem.novelty.text }}</span></p
                        >
                      </div>
                    </div>
                    <div :class="$style.note">{{ cartItem.novelty.note }}</div>
                  </div>
                </div>
                <div>
                  <div :class="$style.price_wrapper">
                    <template v-if="cartItem.discountLate">
                      <div :class="$style.original_price">
                        <span :class="[$style.price, $style.strike_through]"
                          >&yen;{{ getPrice(cartItem).toLocaleString() }}</span
                        >
                      </div>
                      <div :class="$style.discounted_price">
                        <span :class="$style.price">&yen;{{ getDiscountPrice(cartItem).toLocaleString() }}</span>
                        参考税込
                      </div>
                    </template>
                    <div v-else :class="$style.discounted_price">
                      <span :class="$style.price">&yen;{{ getDiscountPrice(cartItem).toLocaleString() }}</span>
                      参考税込
                    </div>
                  </div>
                  <AtomsConsumerLink :url="getUrl(cartItem)">
                    <AtomsConsumerButton :class="$style.add_cart_button">{{
                      isSelectSet(cartItem) ? "セットを選んで購入" : "購入"
                    }}</AtomsConsumerButton>
                  </AtomsConsumerLink>
                </div>
              </div>
            </div>
          </div>
          <AtomsConsumerLink
            v-if="cartItem.otherItem"
            :url="cartItem.otherItem?.url"
            :class="$style.other_item"
            class="scroll-fade"
          >
            <AtomsConsumerButton :class="$style.other_item_button">
              {{ cartItem.otherItem?.title }}
            </AtomsConsumerButton>
          </AtomsConsumerLink>
          <AtomsConsumerLink
            v-if="cartItem.detailBanner"
            :url="cartItem.detailBanner?.url"
            :class="$style.detail_banner"
            class="scroll-fade"
          >
            <AtomsConsumerImage
              v-if="cartItem.detailBanner?.pc_img"
              :src="cartItem.detailBanner?.pc_img"
              :alt="cartItem.detailBanner.alt"
              :class="$style.pc_image"
              class="scroll-fade"
              :width="1440"
              :height="240"
            />
            <AtomsConsumerImage
              v-if="cartItem.detailBanner?.sp_img"
              :src="cartItem.detailBanner?.sp_img"
              :alt="cartItem.detailBanner.alt"
              :class="$style.sp_image"
              class="scroll-fade"
              :width="335"
              :height="226"
            />
          </AtomsConsumerLink>
        </div>
      </div>
    </section>
    <section id="collection" :class="$style.collection">
      <h2 :class="$style.label_title" class="scroll-fade">
        <p :class="[$style.label, $style.pink, $style.text_xl, $style.space]"
          >あなたの「想いを伝えるアイテム」がきっと見つかる。</p
        >
        <p :class="[$style.label, $style.blue, $style.text_xl, $style.space]">TENTIALのギフトセレクション</p>
        <p :class="[$style.label, $style.white, $style.text_md]">人気商品</p>
      </h2>
      <div :class="$style.product_list_wrapper" class="scroll-fade">
        <PagePartsProductListCarousel :item-length="recommendProducts.length">
          <template #items>
            <div v-for="product in recommendProducts" :key="product.document_id" :class="[$style.product_list_item]">
              <div :class="[$style.thumb, { [$style.out_of_stock]: !product.isInStock }]">
                <AtomsConsumerLink :url="product.url">
                  <AtomsConsumerImage
                    :src="`${product.img}`"
                    :alt="product.name"
                    :width="330"
                    :height="440"
                    :class="$style.img"
                  />
                </AtomsConsumerLink>
              </div>
              <AtomsConsumerLink :url="product.url" :class="$style.product_detail">
                <div :class="$style.description_box">
                  <div>
                    <p :class="[$style.name, $style.second_dotted_line]">{{ product.name }}</p>
                    <p :class="[$style.description_text, $style.second_dotted_line]">{{ product.subText }}</p>
                  </div>
                  <div :class="$style.price_box">
                    <div :class="$style.price">
                      <div>
                        <span :class="$style.yen">&yen; </span>
                        <span>
                          {{ product.price?.toLocaleString() }}
                        </span>
                        <span :class="$style.tax">(参考税込)</span>
                      </div>
                    </div>
                    <span :class="$style.buy_button">BUY</span>
                  </div>
                </div>
              </AtomsConsumerLink>
            </div>
          </template>
          <template #spItems>
            <div v-for="product in recommendProducts" :key="product.document_id" :class="[$style.product_list_item]">
              <div :class="[$style.thumb, { [$style.out_of_stock]: !product.isInStock }]">
                <AtomsConsumerLink :url="product.url">
                  <AtomsConsumerImage
                    :src="`${product.img}`"
                    :alt="product.name"
                    :width="267"
                    :height="360"
                    :class="$style.img"
                  />
                </AtomsConsumerLink>
              </div>
              <AtomsConsumerLink :url="product.url" :class="$style.product_detail">
                <div :class="$style.description_box">
                  <div>
                    <p :class="[$style.name, $style.second_dotted_line]">{{ product.name }}</p>
                    <p :class="[$style.description_text, $style.second_dotted_line]">{{ product.subText }}</p>
                  </div>
                  <div :class="$style.price_box">
                    <div :class="$style.price">
                      <div>
                        <span :class="$style.yen">&yen; </span>
                        <span>
                          {{ product.price?.toLocaleString() }}
                        </span>
                        <span :class="$style.tax">(参考税込)</span>
                      </div>
                    </div>
                    <span :class="$style.buy_button">BUY</span>
                  </div>
                </div>
              </AtomsConsumerLink>
            </div>
          </template>
        </PagePartsProductListCarousel>
      </div>
    </section>
    <section id="what-is-bakune" :class="$style.what_is_bakune">
      <h2 :class="$style.label_title" class="scroll-fade">
        <p :class="[$style.label, $style.pink, $style.text_xl, $style.space]">健康を贈る</p>
        <p :class="[$style.label, $style.blue, $style.text_xl, $style.space]">感謝の気持ちをリカバリーウェアに込めて</p>
        <p :class="[$style.label, $style.white, $style.text_md]"
          >BAKUNE<span :class="[$style.label, $style.text_lg]"> 3</span>つのこだわり</p
        >
      </h2>
      <div :class="$style.side_by_side_items" class="scroll-fade">
        <div :class="$style.side_item">
          <div :class="$style.item">
            <div :class="$style.content">
              <p :class="$style.number">01</p>
              <h3 :class="$style.title">着て寝るだけで疲労回復を促進</h3>
              <p :class="$style.tips">
                体から発せられる遠赤外線を輻射させる特殊繊維「SELFLAME®︎」を使用。<br />血行が促進されることで、疲労回復を期待できます。
              </p>
            </div>
            <div :class="$style.image_wrapper">
              <video
                :class="$style.video"
                src="https://kencoco-pro.s3.amazonaws.com/site/ho6j1mpfdko-1723614160419.mp4"
                autoplay
                preload="auto"
                loop
                playsinline
                muted
              ></video>
            </div>
          </div>
        </div>
        <div :class="$style.side_item">
          <div :class="$style.item">
            <div :class="$style.content">
              <p :class="$style.number">02</p>
              <h3 :class="$style.title">{{ `独自の形状で\n自然な寝返りをサポート` }}</h3>
              <p :class="$style.tips">
                肩や腕回りの形状を工夫し、寝返りを打ちやすく設計しました。<br />寝返りを打つ時に服がまとわりつきにくく、体をスムーズに動かすことができるため、<br />自然な寝返りをサポートします。
              </p>
            </div>
            <div :class="$style.image_wrapper">
              <AtomsConsumerImage
                src="/images/site/feature/mothers-fathers-day-2025/bakune-02.jpeg"
                alt="独自の形状で自然な寝返りをサポート"
                :width="md ? 720 : 335"
                :height="md ? 408 : 190"
              />
            </div>
          </div>
        </div>
        <div :class="$style.side_item">
          <div :class="$style.item">
            <div :class="$style.content">
              <p :class="$style.number">03</p>
              <h3 :class="$style.title">{{ `軽く柔らかな肌触りで\n睡眠中のストレスを軽減` }}</h3>
              <p :class="$style.tips">
                生地にシアバター加工を施し、肌への摩擦を軽減し着心地の良さを追求。<br />摩擦が軽減されることで、洗濯すると気になる毛玉もできにくくなりました。
              </p>
            </div>
            <div :class="$style.image_wrapper">
              <AtomsConsumerImage
                src="/images/site/feature/mothers-fathers-day-2025/bakune-03.jpeg"
                alt="軽く柔らかな肌触りで睡眠中のストレスを軽減"
                :width="md ? 720 : 335"
                :height="md ? 408 : 190"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="gift-service" :class="$style.other">
      <h2 :class="$style.label_title" class="scroll-fade">
        <p :class="[$style.label, $style.pink, $style.text_xl, $style.space]">TENTIALの</p>
        <p :class="[$style.label, $style.blue, $style.text_xl, $style.space]">特別なギフトサービス</p>
        <p :class="[$style.label, $style.white, $style.text_md]">eギフト&ギフトレシート</p>
      </h2>
      <div :class="$style.side_by_side_items" class="scroll-fade">
        <div :class="$style.side_item">
          <div :class="$style.item">
            <div :class="$style.content">
              <p :class="$style.label">eギフトにも対応</p>
              <h3 :class="$style.title">簡単に贈り物が送れるeギフト</h3>
              <p :class="$style.tips">
                あなたの「贈る想い」を相手に最大限に喜んでもらうための新しい選択肢。例えば「プレゼントを送りたいけれど、サイズや好みの色がわからない」「都合のいい受取日時がわからない」「今すぐ贈りたいけれど、配送が間に合わない」といったとき。eギフトなら、LINEやSNSなどで受取URLを送ることで、簡単かつスマートな贈り物が可能に。さらに、心を込めたメッセージを伝えられます。
              </p>
              <div :class="$style.gift_link">
                <AtomsConsumerLink url="/features/tential-e-gift" :class="$style.link">
                  詳細はこちら→
                </AtomsConsumerLink>
              </div>
            </div>
            <div :class="$style.image_wrapper">
              <AtomsConsumerImage
                src="/images/site/feature/mothers-fathers-day-2025/egift.jpeg"
                alt="簡単に贈り物が送れるeギフト"
                :width="md ? 720 : 335"
                :height="md ? 408 : 190"
              />
            </div>
          </div>
        </div>
        <div :class="$style.side_item">
          <div :class="$style.item">
            <div :class="$style.content">
              <p :class="$style.label">もしサイズを間違えてしまっても</p>
              <h3 :class="$style.title"
                >ギフトレシートでサイズ交換可能。<br />受け取った方がご自身でぴったり<br />サイズに交換。</h3
              >
              <p :class="$style.tips">
                URLを送るだけでギフトを受け取った方がご自身でサイズを交換することができます。
              </p>
              <div :class="$style.gift_link">
                <AtomsConsumerLink url="/features/gift-receipt" :class="$style.link"> 詳細はこちら→ </AtomsConsumerLink>
              </div>
            </div>
            <div :class="$style.image_wrapper">
              <AtomsConsumerImage
                src="/images/site/feature/mothers-fathers-day-2025/gift-receipt.jpeg"
                alt="ギフトレシートでサイズ交換可能。受け取った方がご自身でぴったりサイズに交換。"
                :width="md ? 720 : 335"
                :height="md ? 408 : 190"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section :class="$style.service">
      <h2 :class="$style.label_title" class="scroll-fade">
        <p :class="[$style.label, $style.pink, $style.text_xl, $style.space]">TENTIAL</p>
        <p :class="[$style.label, $style.blue, $style.text_xl, $style.space]">Other Service</p>
        <p :class="[$style.label, $style.white, $style.text_md]">その他のサービス</p>
      </h2>
      <div :class="$style.side_by_side_items" class="scroll-fade">
        <div :class="$style.side_item">
          <div :class="$style.item">
            <div :class="$style.content">
              <h3 :class="$style.title">TENTIAL OFFICIAL STOREでも<br />母の日・父の日キャンペーンを実施中！</h3>
              <div :class="$style.tips">
                <p>
                  直営店舗「TENTIAL OFFI CIAL STORE」のほか、<br />
                  期間限定ポップアップショップも展開！
                </p>
                <p :class="$style.explanation">
                  ※取扱い商品は、店舗によって異なります。商品ページ内の「店舗在庫状況」からご確認ください。<br />
                  ※スペシャルギフトカードについては取扱いがございません。予めご了承ください。
                </p>
              </div>
              <div :class="$style.store_link">
                <AtomsConsumerLink url="/shop" :class="$style.link"> 店舗を探す→ </AtomsConsumerLink>
              </div>
            </div>
            <div :class="$style.image_wrapper">
              <AtomsConsumerImage
                src="/images/site/feature/mothers-fathers-day-2025/store.jpeg"
                alt="TENTIAL OFFICIAL STORE"
                :width="md ? 720 : 335"
                :height="md ? 408 : 190"
              />
            </div>
          </div>
        </div>
      </div>
      <AtomsConsumerLink url="/features/tential-gift-service" :class="$style.gift_image" class="scroll-fade">
        <AtomsConsumerImage
          src="/images/site/feature/mothers-fathers-day-2025/wrapping-pc.jpeg"
          alt="Self Wrapping"
          :width="1440"
          :height="240"
          :class="$style.pc_image"
        />
        <AtomsConsumerImage
          src="/images/site/feature/mothers-fathers-day-2025/wrapping-sp.jpeg"
          alt="Self Wrapping"
          :width="335"
          :height="226"
          :class="$style.sp_image"
        />
      </AtomsConsumerLink>
    </section>
    <div v-if="isShowModal" :class="$style.modal">
      <div :class="$style.modal_overlay" @click="isShowModal = false"></div>
      <div :class="$style.modal_content">
        <AtomsConsumerImage :src="modalImage" alt="拡大画像" />
        <div :class="$style.close" @click="isShowModal = false">&times;</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import dayjs from "dayjs"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import type { GiftSetProduct, RecommendProduct } from "~/utils/functions/MothersFathersDay2025"

const config = useRuntimeConfig()
const isProduction = config.public.APP_ENV === "production"

const props = withDefaults(
  defineProps<{
    isFathersDay: boolean
    giftSetProducts: GiftSetProduct[]
    recommendProducts: RecommendProduct[]
  }>(),
  {
    isFathersDay: false,
  },
)

const { width: windowWidth } = useWindowSize()
const md = computed(() => windowWidth.value >= 768)

/** 父の日当日までに配送が可能期間 */
const isFathersDayDeliverable = computed(() => {
  if (isProduction) {
    return dayjs().isBetween("2025-05-30", "2025-06-10", null, "[]")
  }

  // dev環境ではクエリにd=1がある場合はtrueにする
  const route = useRoute()
  const deliverable = route.query.d
  return !!deliverable
})

const scrollToId = (documentId: string | undefined): void => {
  if (!documentId) return
  const element = document.getElementById(documentId)
  element?.scrollIntoView({
    behavior: "smooth",
  })
}

const images = {
  mainPc: `/images/site/feature/mothers-fathers-day-2025/${props.isFathersDay ? "fathers-day-" : ""}main-pc.jpeg`,
  mainSp: `/images/site/feature/mothers-fathers-day-2025/${props.isFathersDay ? "fathers-day-" : ""}main-sp.jpeg`,
  thankYouPc: `/images/site/feature/mothers-fathers-day-2025/${
    props.isFathersDay ? "fathers-day-" : ""
  }thank-you-pc.png`,
  thankYouSp: `/images/site/feature/mothers-fathers-day-2025/${
    props.isFathersDay ? "fathers-day-" : ""
  }thank-you-sp.png`,
  freeWrapping: `/images/site/feature/mothers-fathers-day-2025/${
    props.isFathersDay ? "fathers-day-" : ""
  }free-wrapping.png`,
  number1: `/images/site/feature/mothers-fathers-day-2025/${props.isFathersDay ? "fathers-day-" : ""}number-1-3.png`,
  number2: `/images/site/feature/mothers-fathers-day-2025/${props.isFathersDay ? "fathers-day-" : ""}number-2-3.png`,
  number3: `/images/site/feature/mothers-fathers-day-2025/${props.isFathersDay ? "fathers-day-" : ""}number-3-3.png`,
}

const isShowModal = ref(false)
const modalImage = ref("")

const getPrice = (cartItem: GiftSetProduct) => {
  const selectedProducts = cartItem.selectedProducts.map((index, i) => {
    return cartItem.products[i]?.selectItems[Number(index)]?.price ?? 0
  })
  const totalPrice = selectedProducts.reduce((acc, price) => acc + price, 0)
  return totalPrice
}

const getDiscountPrice = (cartItem: GiftSetProduct) => {
  const totalPrice = getPrice(cartItem)
  const discountPrice = cartItem.discountLate ? Math.floor(totalPrice * (1 - cartItem.discountLate / 100)) : totalPrice
  return discountPrice
}

const getUrl = (cartItem: GiftSetProduct) => {
  const product1 = cartItem.products[0].selectItems[Number(cartItem.selectedProducts[0])]
  const product2 = cartItem.products[1]?.selectItems[Number(cartItem.selectedProducts[1])]
  const documentIds = [product1.documentId, product2?.documentId].filter(Boolean)
  const url = cartItem.urlTable.find((item) => {
    return JSON.stringify(item.documentIds.sort()) === JSON.stringify(documentIds.sort())
  })?.url
  return url ?? ""
}

const isSelectSet = (cartItem: GiftSetProduct) => {
  return (
    cartItem.products.length > 1 &&
    (cartItem.products[0].selectItems.length > 1 || cartItem.products[1].selectItems.length > 1)
  )
}

const isSetSoldOut = (cartItem: GiftSetProduct) => {
  return cartItem.products.some((productGroup) => productGroup.selectItems.every((product) => !product.isInStock))
}

const showModal = (img: string) => {
  if (!md.value) return
  modalImage.value = img
  isShowModal.value = true
}

onMounted(() => {
  if (!process.client) return
  gsap.registerPlugin(ScrollTrigger)
  // 画面描画したら .first-view をゆっくり表示
  gsap.to(".first-view", {
    opacity: 1,
    delay: 0.5,
    duration: 1,
    scrollTrigger: {
      trigger: ".first-view",
      start: "top 70%",
      end: "bottom 30%",
      toggleActions: "play none none none",
    },
  })

  const fadeElements = document.querySelectorAll(".scroll-fade")
  fadeElements.forEach((el) => {
    gsap.from(el, {
      opacity: 0,
      y: 50,
      duration: 1.5,
      scrollTrigger: {
        trigger: el,
        start: "top bottom",
        toggleActions: "play none none none",
      },
    })
  })
})

onUnmounted(() => {
  ScrollTrigger.getAll().forEach((trigger) => {
    trigger.kill()
  })
})
</script>

<style lang="scss" scoped module>
$page-bg: #faf2e7;
$page-bg-accent: #fcf9f4;

* {
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", sans-serif;
}

@mixin main($main-color: #ee9eb1) {
  &.fathers_day {
    section.intro {
      background-image: url("/images/site/feature/mothers-fathers-day-2025/fathers-day-background-image-sp.jpeg");
      @include md {
        background-image: url("/images/site/feature/mothers-fathers-day-2025/fathers-day-background-image-pc.jpeg");
      }
    }
  }

  background-color: $page-bg;
  color: $black-60;
  font-size: $font-size-12;
  @include md {
    font-size: $font-size-14;
  }
  br {
    &.pc {
      display: none;
      @include md {
        display: block;
      }
    }
    &.sp {
      display: block;
      @include md {
        display: none;
      }
    }
  }
  .button {
    color: $main-color;
    white-space: nowrap;
    padding: 0.75rem 1.125rem;
    @include md {
      padding: 0.75rem 2rem;
    }
  }
  .header_section {
    opacity: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100svh - 3rem);
    @media screen and (max-width: 1300px) {
      height: calc(80svh - 4rem);
    }
    @media screen and (max-width: 1100px) {
      height: calc(60svh - 4rem);
    }
    @include sp {
      height: calc(100svh - 3rem);
    }
    .title {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .side_by_side_items {
    display: flex;
    flex-direction: column;
    gap: 3rem;
    line-height: 2;
    .side_item {
      position: relative;
      .number_sp {
        width: 100%;
        display: flex;
        justify-content: center;
        padding-bottom: 1rem;
        @include md {
          display: none;
        }
      }
      .free_wrapping {
        position: absolute;
        top: 0;
        right: 0;
        @include md {
          left: -25px;
          top: -50px;
        }
      }
      @include md {
        .item {
          flex-direction: row-reverse;
        }
        &:nth-child(2n) {
          .item {
            flex-direction: row;
          }
        }
      }
    }
    .item {
      display: flex;
      flex-direction: column-reverse;
      position: relative;
      background-color: $white;
      border-radius: 3px;
      overflow: hidden;
      @include md {
        height: 370px;
        max-height: 620px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 1rem;
        flex-direction: row-reverse;
      }
      & > div {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
        width: 100%;
        @include md {
          width: 50%;
        }
      }
      .content {
        padding: 1rem 1.5rem;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        @include md {
          padding: 0.5rem 1.5rem;
        }
        @include lg {
          padding: 1rem 2.5rem;
        }
        h3 {
          font-size: $font-size-15;
          line-height: 1.5;
          font-weight: normal;
          color: $black-60;
          @include sp {
            font-weight: bold;
          }
          @include md {
            font-size: $font-size-20;
          }
          @include lg {
            font-size: $font-size-24;
          }
        }
        .description {
          font-size: $font-size-13;
          @include md {
            line-height: 1.5;
          }
          @include lg {
            line-height: 2;
          }
          .limited_color {
            font-size: $font-size-13;
            background-color: #faf2e7;
            font-weight: bold;
            padding: 0 0.2rem;
          }
        }
        .label {
          @include main-font;
          font-size: $font-size-18;
          color: $white;
          background-color: $main-color;
          padding: 0 0.5rem;
          line-height: 1.5;
        }
        .number {
          @include main-font;
          font-size: $font-size-26;
          color: $main-color;
          line-height: normal;
          @include md {
            font-size: $font-size-32;
          }
          @include lg {
            font-size: $font-size-40;
          }
        }
        .text {
          color: $black;
          margin-bottom: 1rem;
          line-height: 1.5rem;
          font-size: $font-size-12;
          @include md {
            font-size: $font-size-14;
            line-height: 1.5rem;
            margin-bottom: 0.625rem;
          }
          @include lg {
            font-size: $font-size-16;
            line-height: 2rem;
            margin-bottom: 0.625rem;
          }
        }
        .tips {
          margin-bottom: 1rem;
          font-size: $font-size-13;
          line-height: 1.6;
          .explanation {
            padding-top: 0.5rem;
            font-size: $font-size-11;
          }
        }
        .price_wrapper {
          margin-bottom: 2rem;
          text-align: right;
          white-space: normal;
          line-height: normal;
          @include md {
            margin-bottom: 1rem;
          }
          .price {
            font-size: $font-size-22;
            font-weight: bold;
            margin-right: 0.25rem;
          }
        }
        .button_wrapper {
          display: flex;
          justify-content: center;
          .detail_button {
            color: $white;
            padding: 0.25rem 3rem;
            border: 1px solid $white;
            border-radius: 1.5rem;
          }
        }
      }
      .image_wrapper {
        position: relative;
        width: 100%;
        @include md {
          width: 50%;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        .tips {
          line-height: 1.6;
          font-size: $font-size-14;
          margin-top: 0.625rem;
          display: none;
          @include md {
            display: block;
          }
        }
      }
      .pc {
        display: none;
        @include md {
          display: block;
        }
      }
      .sp_num {
        display: flex;
        justify-content: center;
        align-items: center;
        @include md {
          display: none;
        }
        img {
          width: 50px;
          height: 50px;
        }
      }
    }
  }

  section {
    .label_title {
      display: flex;
      width: auto;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 0.5rem;
      width: 100%;
      font-size: $font-size-20;
      @include md {
        font-size: $font-size-40;
      }
      .label {
        @include main-font;
        &.text_xl {
          font-size: $font-size-18;
          @include md {
            font-size: $font-size-30;
          }
        }
        &.text_lg {
          font-size: $font-size-16;
          @include md {
            font-size: $font-size-30;
          }
        }
        &.text_md {
          font-size: $font-size-13;
          @include md {
            font-size: $font-size-20;
          }
        }
        &.text_sm {
          font-size: $font-size-9;
          @include md {
            font-size: $font-size-12;
          }
        }
        &.pink {
          background-color: #ee9eb1;
          color: $white;
          line-height: 1.25;
          padding: 0.2rem;
        }
        &.blue {
          background-color: #3f5f85;
          color: $white;
          line-height: 1.25;
          padding: 0.2rem;
        }
        &.white {
          background-color: $white;
          color: $black-60;
          line-height: 1.25;
          padding: 0.2rem;
        }
        &.space {
          letter-spacing: 2px;
        }
      }
    }
    h3.title {
      font-size: $font-size-16;
      color: $main-color;
      @include md {
        font-size: $font-size-24;
      }
    }
  }

  section:not(.no_padding) {
    padding: 5rem 1rem;
    @include md {
      padding: 5rem;
    }
  }

  section.intro {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    color: $main-color;
    background-image: url("/images/site/feature/mothers-fathers-day-2025/background-image-sp.jpeg");
    background-size: cover;
    @include md {
      gap: 3rem;
      padding-top: 8rem;
      padding-bottom: 8rem;
      background-image: url("/images/site/feature/mothers-fathers-day-2025/background-image-pc.jpeg");
    }
    h2 {
      font-size: $font-size-17;
      text-align: center;
      justify-content: center;
      align-items: center;
      @include md {
        font-size: $font-size-32;
      }
    }
    .description {
      font-size: $font-size-14;
      text-align: center;
      color: $black-60;
      line-height: 2.5;
      max-width: 60rem;
      @include md {
        line-height: 3;
        font-size: $font-size-17;
      }
    }
    .intro_image {
      @include full-container-md;
      margin-top: 3rem;
    }
    .navigation_list {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      margin-top: 2rem;
      width: 100%;
      flex-direction: row;
      @include md {
        gap: 2rem;
      }
      button {
        display: flex;
        flex-direction: column;
        gap: 0.2rem;
        align-items: center;
        justify-content: center;
        width: 20%;
        max-width: 338px;
        background-color: white;
        border: 1px solid $main-color;
        border-radius: 1.5rem;
        padding: 0.25rem;
        @include md {
          aspect-ratio: 338 / 179;
        }
        @include sp {
          height: 90px;
        }
        @media screen and (max-width: 1200px) {
          width: 45%;
        }
        &:nth-child(1) {
          border-radius: 2rem 0 0 0;
        }
        &:nth-child(2) {
          border-radius: 0 0 0 2rem;
        }
        &:nth-child(3) {
          border-radius: 0 2rem 0 0;
        }
        &:nth-child(4) {
          border-radius: 0 0 0 2rem;
        }
        @include md {
          &:nth-child(1) {
            border-radius: 4rem 0 0 0;
          }
          &:nth-child(2) {
            border-radius: 0 0 0 4rem;
          }
          &:nth-child(3) {
            border-radius: 0 4rem 0 0;
          }
          &:nth-child(4) {
            border-radius: 0 0 0 4rem;
          }
        }
        .number {
          font-size: $font-size-22;
          color: $main-color;
          @media screen and (max-width: 1400px) {
            font-size: $font-size-18;
          }
          @include sp {
            font-size: $font-size-12;
          }
        }
        .title {
          font-size: $font-size-16;
          color: $black-60;
          display: flex;
          align-items: center;
          justify-content: center;
          @media screen and (max-width: 1400px) {
            font-size: $font-size-14;
          }
          @include sp {
            font-size: $font-size-12;
          }
        }
        .arrow {
          font-size: $font-size-16;
          color: $main-color;
          @media screen and (max-width: 1400px) {
            font-size: $font-size-14;
          }
          @include sp {
            font-size: $font-size-12;
          }
        }
        &:hover {
          background-color: $main-color;
          color: $white;
          p {
            color: $white;
          }
        }
      }
    }
  }
  section.campaign {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    background-color: $page-bg-accent;
    @include md {
      padding-top: 8rem;
      padding-bottom: 8rem;
    }
    .label_title {
      line-height: 1.5;
      font-size: $font-size-19;
      @include md {
        line-height: 1.3;
        font-weight: normal;
        letter-spacing: 4px;
      }
    }
    .campaign_title {
      display: flex;
      text-align: center;
    }
    .image_wrapper {
      @include md {
        cursor: pointer;
      }
      &.no_pointer {
        cursor: default;
      }
    }
    .title_wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      h2 {
        font-size: $font-size-19;
        text-align: center;
        letter-spacing: 0.125rem;
        align-items: center;
        @include md {
          font-size: $font-size-36;
        }
      }
      .date {
        @include main-font;
        font-size: $font-size-16;
        color: $white;
        background-color: $main-color;
        line-height: 1.5;
        width: 100%;
        text-align: center;
        margin: 0.5rem 0;
        @include md {
          font-size: $font-size-30;
          width: fit-content;
          margin-top: 1rem;
          padding: 0 1rem;
          letter-spacing: 2px;
        }
      }
      .date_note {
        margin: 0.25rem 0 0.5rem;
        @include md {
          margin: 0 0 1.5rem 0;
        }
      }
      .delivery_date_note {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
        margin-bottom: 1.75rem;
        @include md {
          gap: 0.5rem;
        }
        .delivery_date_note_item {
          .bg_white {
            background-color: $white;
            padding: 0.25rem 0.5rem;
          }
          &.red_text {
            color: $danger;
            font-size: $font-size-12;
            line-height: 1.8;
            text-align: center;
            @include md {
              font-size: $font-size-16;
              line-height: 1.75;
            }
            .underline {
              text-decoration: underline;
            }
          }
          @include md {
            text-align: center;
          }
        }
      }
      .campaign_note {
        font-weight: bold;
        position: relative;
        text-align: center;
        font-size: $font-size-14;
        color: $main-color;
        margin-bottom: 3rem;
        border: 1px solid $main-color;
        padding: 0.5rem 1rem;
        width: 100%;
        @include md {
          width: fit-content;
          font-size: $font-size-19;
          letter-spacing: 2px;
        }
        span {
          font-weight: bold;
          @include sp {
            color: $white;
            background-color: $main-color;
            padding: 0 0.2rem;
          }
        }
      }
    }
    .number {
      display: none;
      @include md {
        display: block;
      }
    }
  }
  section.gift_set {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    @include md {
      padding-top: 8rem;
      padding-bottom: 8rem;
    }
    .text {
      line-height: 2.38;
      margin-bottom: 2rem;
      font-size: $font-size-12;
      @include md {
        font-size: $font-size-14;
      }
    }
  }
  section.gift_set {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    background-color: #faf2e7;
    padding-top: 5rem;
    padding-bottom: 5rem;
    @include md {
      gap: 3rem;
      padding-top: 8rem;
      padding-bottom: 8rem;
    }
    .title_image {
      width: 100%;
    }
    .note {
      display: flex;
    }
    .gift_products {
      display: flex;
      flex-direction: column;
      gap: 3rem;
      width: 100%;
      @include md {
        gap: 5rem;
      }
      .item_name {
        padding-top: 0.5rem;
        font-weight: bold;
      }
      .product_wrapper {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        .product {
          position: relative;
          display: flex;
          flex-direction: column;
          background-color: $white;
          padding: 2rem 1rem;
          width: 100%;
          gap: 3rem;
          border-radius: 3px;
          @include md {
            flex-direction: row;
            padding: 4rem;
          }
          .left {
            display: flex;
            flex-direction: column;
            width: 50%;
            gap: 1rem;
            .image_wrapper {
              display: flex;
              gap: 1rem;
              .image {
                width: 100%;
                object-fit: cover;
                border-radius: 0.3125rem;
              }
            }
          }
          .product_item {
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: 1rem;
            @include md {
              flex-direction: row;
              gap: 3rem;
            }
            .pc_images {
              display: none;
              @media screen and (min-width: 1000px) {
                display: block;
              }
              flex: 1.3;
              .image_wrapper {
                padding-bottom: 2rem;
                display: flex;
                gap: 1.5rem;
                .product_image {
                  .image {
                    width: 100%;
                  }
                }
              }
            }
            .image {
              width: 100%;
              object-fit: cover;
              border-radius: 0.3125rem;
            }
            .detail {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              width: 100%;
              flex: 1;
              gap: 1rem;
              @include md {
                gap: 2rem;
              }
              .product_info {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                .label_title {
                  padding: 0;
                }
                .link {
                  padding-top: 1rem;
                }
                .discount {
                  @include main-font;
                  font-size: $font-size-16;
                  @include md {
                    font-size: $font-size-24;
                  }
                  .discount_late {
                    @include main-font;
                    color: #ee9eb1;
                  }
                }
                @media screen and (min-width: 1000px) {
                  .product_list_wrapper {
                    display: none;
                  }
                }
                .products_note {
                  display: flex;
                  font-size: $font-size-11;
                  white-space: normal;
                  word-wrap: normal;
                  @include md {
                    white-space: pre-wrap;
                    word-wrap: break-word;
                  }
                }
                .product_name {
                  @include main-font;
                  font-size: $font-size-20;
                  line-height: 1.2;
                  @include md {
                    font-size: $font-size-30;
                    letter-spacing: 2px;
                  }
                }
                .description {
                  font-size: $font-size-12;
                  @include md {
                    font-size: $font-size-14;
                    line-height: 2;
                  }
                }
                .one_select_product {
                  font-size: $font-size-16;
                }
                .new_item_label {
                  font-size: $font-size-18;
                  color: #ee9eb1;
                  font-weight: bold;
                }
                .info {
                  font-size: $font-size-10;
                  @include md {
                    font-size: $font-size-12;
                  }
                }
                .product_image {
                  min-width: 250px;
                }
                .select_label {
                  padding: 0.75rem 0 0.5rem 0;
                }
              }
              .price_wrapper {
                @include main-font;
                display: flex;
                align-items: center;
                justify-content: right;
                gap: 0.5rem;
                font-size: $font-size-18;
                @include sp {
                  padding-top: 1rem;
                }
                .price {
                  @include main-font;
                }
                .strike_through {
                  text-decoration: line-through;
                }
                .original_price {
                  font-size: $font-size-12;
                  .price {
                    font-size: $font-size-18;
                  }
                }
                .discounted_price {
                  color: #cb4252;
                  font-size: $font-size-12;
                  .price {
                    font-size: $font-size-24;
                  }
                }
              }
              .add_cart_button {
                @include main-font;
                background-color: $main-color;
                color: $white;
                width: 100%;
                padding: 1rem 1rem;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 0.3125rem;
                font-size: $font-size-12;
                border: solid 1px $main-color;
                @include md {
                  font-size: $font-size-14;
                }
                &:hover {
                  background-color: white;
                  color: $main-color;
                  border: solid 1px $main-color;
                }
              }
            }
            .novelty {
              padding-top: 0.5rem;
              &.novelty_sp {
                display: block;
                @media screen and (min-width: 1000px) {
                  display: none;
                }
              }
              &.novelty_pc {
                display: none;
                @media screen and (min-width: 1000px) {
                  display: block;
                }
              }
              .novelty_wrapper {
                display: flex;
                border-radius: 0.3125rem;
                overflow: hidden;
                .novelty_image_wrapper {
                  position: relative;
                  display: flex;
                  flex: 0.6;
                  .novelty_image {
                    display: flex;
                    img {
                      width: 100%;
                      object-fit: cover;
                    }
                    &.out_of_stock {
                      &::after {
                        font-size: $font-size-16;
                      }
                    }
                  }
                }
                .novelty_text {
                  flex: 1;
                  display: flex;
                  align-items: center;
                  background-color: #f8f8fa;
                  padding: 0.5rem;
                  @include md {
                    padding: 1.5rem 1.5rem;
                  }
                  p {
                    span {
                      padding: 2px;
                      font-size: $font-size-13;
                      font-weight: bold;
                      color: $main-color;
                      background-color: $white;
                      @include md {
                        font-size: $font-size-19;
                        white-space: pre-wrap;
                        word-wrap: break-word;
                        letter-spacing: 2px;
                      }
                    }
                  }
                }
              }
              .note {
                font-size: $font-size-10;
                color: #5a5a5a;
                @include md {
                  font-size: $font-size-11;
                  padding-top: 0.5rem;
                  white-space: pre-wrap;
                  word-wrap: break-word;
                }
              }
            }
          }
          &.most_popular {
            &::before {
              content: "";
              top: 0;
              right: 0;
              border-bottom: 8em solid transparent;
              border-right: 8em solid #ee9eb1;
              position: absolute;
              z-index: 100;
              border-radius: 3px;
              @include md {
                border-bottom: 10em solid transparent;
                border-right: 10em solid #ee9eb1;
              }
            }
            &::after {
              content: "一番人気！";
              display: block;
              top: 25px;
              right: 10px;
              color: $white;
              right: 0;
              font-size: $font-size-14;
              font-weight: bold;
              position: absolute;
              z-index: 101;
              border-radius: 3px;
              rotate: 45deg;
              @include md {
                rotate: 0deg;
                font-size: $font-size-16;
              }
            }
          }
        }
        .other_item {
          display: flex;
          justify-content: center;
          padding: 1rem 0;
          .other_item_button {
            background-color: white;
            border: solid 1px $primary-40;
            color: #111111;
            font-size: $font-size-12;
            padding: 0.5rem;
            border-radius: 4px;
            width: 100%;
            text-align: center;
            display: flex;
            justify-content: center;
            font-weight: normal;
            white-space: pre-wrap;
            word-wrap: break-word;
            @include md {
              width: fit-content;
              padding: 1rem 3rem;
              white-space: normal;
              word-wrap: normal;
            }
          }
        }
        .sold_out {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 1000;
          pointer-events: none;
          display: flex;
          justify-content: center;
          align-items: center;
          color: white;
          font-size: $font-size-24;
          border-radius: 3px;
        }
        .detail_banner {
          padding: 1rem 0;
          img {
            width: 100%;
          }
        }
      }
    }
  }
  section.collection {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    background-color: $page-bg-accent;
    @include md {
      padding-top: 5.5rem;
      padding-bottom: 5.5rem;
      gap: 3rem;
    }
    .product_list_wrapper {
      .thumb {
        position: relative;
      }
      .product_detail {
        position: relative;
        flex-grow: 1;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        background-color: white;

        .description_box {
          opacity: 1;
          transition: 0.2s opacity;
          flex-grow: 1;
          display: flex;
          flex-flow: column;
          min-height: 120px;
          justify-content: space-between;

          &.hover {
            opacity: 1;
            @include md {
              opacity: 0;
            }
          }

          .name {
            @include main-font;
            font-size: $font-size-17;
          }

          .description_text {
            font-size: $font-size-13;
          }

          .price_box {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .buy_button {
              @include main-font;
              font-size: $font-size-18;
              text-decoration: underline;
            }
          }
          .price {
            display: flex;
            justify-content: space-between;
            align-items: center;
            span {
              @include main-font;
              font-size: $font-size-18;
            }

            .line_through {
              text-decoration: line-through;
              margin-right: 0.25rem;
            }

            .yen {
              font-weight: unset;
            }

            .tax {
              font-size: $font-size-10;
              font-weight: 300;
              line-height: 14px 3vw;
              margin-left: 0.25rem;
            }
          }
        }
      }
    }
  }
  section.what_is_bakune {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    @include md {
      padding-top: 5.5rem;
      padding-bottom: 5.5rem;
      gap: 3rem;
    }
    .video {
      width: 100%;
    }
  }
  section.other {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    background-color: $page-bg-accent;
    @include md {
      padding-top: 5.5rem;
      padding-bottom: 5.5rem;
      gap: 3rem;
    }
    .gift_link {
      width: 100%;
      display: flex;
      justify-content: right;
    }
    .side_by_side_items {
      .content {
        .title {
          padding: 0.5rem 0;
          font-size: $font-size-16;
        }
        .label {
          font-size: $font-size-14;
        }
        @include md {
          .title {
            letter-spacing: 2px;
            font-size: $font-size-28;
            padding: 0.5rem 0;
          }
          .label {
            letter-spacing: 5px;
          }
          .tips {
            line-height: 2;
            font-size: $font-size-14;
          }
        }
      }
    }
  }
  section.service {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    @include md {
      padding-top: 5.5rem;
      padding-bottom: 5.5rem;
      gap: 3rem;
    }
    .store_link {
      width: 100%;
      display: flex;
      justify-content: right;
    }
    .gift_image {
      img {
        width: 100%;
      }
    }
    .side_by_side_items {
      .content {
        .title {
          padding-bottom: 1rem;
        }
        @include md {
          .title {
            letter-spacing: 2px;
            font-size: $font-size-28;
            padding-bottom: 0;
          }
          .tips {
            line-height: 2;
            font-size: $font-size-14;
          }
        }
      }
    }
  }
  .product_list_wrapper {
    .slide {
      cursor: pointer;
      flex: 0 0 70%;
      @include md {
        flex: 0 0 calc(25% - 0.75rem);
      }
    }
  }
  .out_of_stock {
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #111111;
      opacity: 0.2;
      z-index: 1;
      border-radius: 0.375rem 0.375rem 0 0;
      pointer-events: none;
    }
    &::after {
      content: "SOLD OUT";
      display: flex;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      color: white;
      font-size: $font-size-23;
      font-weight: bold;
      opacity: 1;
    }
  }
  .link {
    text-decoration: underline;
    font-weight: normal;
    color: $black-60;
    cursor: pointer;
  }
  .pc_image {
    display: none;
    @include md {
      display: block;
    }
  }
  .sp_image {
    display: block;
    @include md {
      display: none;
    }
  }
  .modal {
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .modal_overlay {
      z-index: 1001;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
    }
    .modal_content {
      z-index: 1002;
      position: relative;
      padding: 1rem;
      img {
        width: 100%;
      }
      .close {
        position: absolute;
        right: 2rem;
        top: 1rem;
        color: #aaa;
        float: right;
        font-size: 24px;
        font-weight: bold;
        cursor: pointer;
        &:hover {
          color: black;
        }
      }
    }
  }
  .not_click {
    pointer-events: none;
    cursor: default;
  }
}
.item {
  .title,
  .description {
    white-space: pre-wrap;
    word-wrap: break-word;
    @include sp {
      white-space: normal;
      word-wrap: normal;
    }
  }
}
.mothers_fathers_day_2025 {
  &.fathers_day {
    @include main(#3f5f85);

    .other_item {
      .other_item_button {
        background-color: #3f5f85 !important;
        border: 1px solid #a9b7cb !important;
        color: $white !important;
        font-weight: bold !important;
        font-size: $font-size-12 !important;
        @include md {
          font-size: $font-size-14 !important;
        }
      }
    }
  }
  &.mothers_day {
    @include main;
  }
}
</style>
